import type { ISyncEngine, OutboxEntry, SyncEvent } from '@erp/native/interfaces';

/**
 * Web has no offline mode in this codebase — the engine accepts entries
 * but immediately marks them done after the caller's mutation succeeds.
 * In practice the React layer should bypass the engine entirely on web
 * (calling the data service directly), but having a no-op preserves the
 * interface so module code doesn't branch on platform.
 */
// Web adapter is a stub — there's no real outbox in the browser.
export function createWebSyncEngine(): ISyncEngine {
  const subs = new Set<(event: SyncEvent) => void>();

  return {
    async enqueue(input) {
      const entry: OutboxEntry = {
        id: crypto.randomUUID(),
        createdAt: new Date().toISOString(),
        attempts: 0,
        status: 'done',
        ...input,
      };
      subs.forEach((cb) => cb({ type: 'queued', entry }));
      subs.forEach((cb) => cb({ type: 'entry_done', entry }));
      return entry;
    },
    async flush() {
      // Nothing to flush on web.
    },
    async pending() {
      return [];
    },
    subscribe(cb) {
      subs.add(cb);
      return () => subs.delete(cb);
    },
    async discard() {
      // Nothing to discard.
    },
    async retryEntry() {
      // Nothing to retry — web outbox is a no-op.
    },
  };
}
